/**
 * Lightweight session store. The HttpOnly cookie holds the actual JWT;
 * this store mirrors the user info so the UI can render without a fetch
 * roundtrip for trivial things like "show the username in the nav".
 */
import { create } from 'zustand';
import type { MenuKey, SessionUser } from '@ope-v3/shared';

interface AuthState {
  user: SessionUser | null;
  /** True until the first /me check resolves — gates the router. */
  initialized: boolean;
  setUser: (user: SessionUser | null) => void;
  setInitialized: (v: boolean) => void;
  canAccess: (key: MenuKey) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  initialized: false,
  setUser: (user) => set({ user }),
  setInitialized: (initialized) => set({ initialized }),
  canAccess: (key) => {
    const u = get().user;
    if (!u) return false;
    if (u.isAdmin) return true;
    return u.accessRights.includes(key);
  },
}));
